export function print(str, obj) {
  if(obj)
    console.log(str, obj);
  else
    console.log(str);
}

export function printError(errorMsg) {
  console.error(errorMsg);
}

export function getAuthToken(){
  let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  if(loggedInUser && loggedInUser.token){
    return loggedInUser.token;
  }
  return "";
}

export function getLoggedInUser(){
  let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  if(loggedInUser){
    return loggedInUser;
  }
  return {};
}

export function getLoggedInUserId(){
  let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  if(loggedInUser){
    return loggedInUser.id;
  }
  return "";
}

export function reduce(numerator,denominator){
  let gcd = function gcd(a,b){
    return b ? gcd(b, a%b) : a;
  };
  gcd = gcd(numerator,denominator);
  return [numerator/gcd, denominator/gcd];
}

export function getUrlParam(param) {
  let params = new URLSearchParams(window.location.search);
  return params.get(param);
}
